import { useTranslation } from 'react-i18next';
import { ReactComponent as DeleteUserIcon } from '../../../assets/Popup_UserDeleted.svg';
import { closePopup } from '../../../shared/appUIFramework/popup/AppPopup';
import { AppPopupLayout } from '../../../shared/appUIFramework/popup/AppPopupLayout';

export default function DeleteEntryUserSuccessPopup(
  {
    userName,
  }: {
        userName: string
    },
) {
  const { t } = useTranslation();
  const cancel = () => closePopup(false);

  return (
    <AppPopupLayout
      headerTitle="DeleteUser_DeleteAUser"
      extraClass="app-popup-delete-user"
      onHeaderClose={cancel}
      popupBody={(
        <>
          <DeleteUserIcon />
          <span className="app-font-20 app-uppercase app-weight-600">
            { t('Popup_UserDeleted') }
          </span>
          <span className="app-font-20 app-pb-33">
            { t('Popup_UserHasBeenDeleted', { userName })}
          </span>
        </>
      )}
    />
  );
}
